/* RVO static PageFly replacement: handles generated page links, variant dropdowns, and product Add To Cart buttons without PageFly. */
(function () {
  function closest(el, selector) { return el && el.closest ? el.closest(selector) : null; }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getProductId(select) {
    var box = closest(select, '[data-pf-type="ProductBox"], [data-product-id], form');
    return select.getAttribute('data-productid') ||
           select.getAttribute('data-product-id') ||
           (box && (box.getAttribute('data-product-id') || box.getAttribute('data-productid'))) ||
           null;
  }

  function getProduct(select) {
    var id = getProductId(select);
    return id && window.__pageflyProducts ? window.__pageflyProducts[String(id)] : null;
  }

  function findVariant(select) {
    var product = getProduct(select);
    var selectedOption = select.options && select.options[select.selectedIndex];
    var rawValue = String(select.value || '');
    var label = selectedOption ? selectedOption.textContent : rawValue;

    if (product && Array.isArray(product.variants)) {
      var byId = product.variants.find(function (v) { return String(v.id) === rawValue; });
      if (byId) return byId;

      var wanted = normalize(label || rawValue);
      return product.variants.find(function (variant) {
        var values = []
          .concat(variant.options || [])
          .concat([variant.option1, variant.option2, variant.option3, variant.title])
          .filter(Boolean)
          .map(normalize);

        return values.some(function (value) {
          return value === wanted || value.indexOf(wanted) !== -1 || wanted.indexOf(value) !== -1;
        });
      }) || null;
    }

    if (/^\d+$/.test(rawValue)) return { id: rawValue };
    return null;
  }

  function syncVariantId(select) {
    var form = closest(select, 'form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var variant = findVariant(select);
    if (idInput && variant && variant.id) idInput.value = variant.id;
  }

  document.addEventListener('change', function (event) {
    var select = closest(event.target, 'select.pf-variant-select');
    if (!select) return;
    syncVariantId(select);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('select.pf-variant-select').forEach(syncVariantId);
  });

  document.addEventListener('click', function (event) {
    var btn = closest(event.target, '[data-pf-type="ProductATC2"], [data-pf-type="AddToCart"]');
    if (btn) {
      var form = closest(btn, 'form');
      if (!form) return;

      var select = form.querySelector('select.pf-variant-select');
      if (select) syncVariantId(select);

      event.preventDefault();
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.dataset.adding || 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      }).then(function () {
        btn.textContent = btn.dataset.added || 'Thank you!';
        document.dispatchEvent(new CustomEvent('rvo:item-added'));
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText || 'Add To Cart';
        }, 1500);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = originalText || 'Add To Cart';
        window.location.href = '/cart';
      });
      return;
    }

    var blockLink = closest(event.target, '[data-href]');
    if (blockLink && !closest(event.target, 'a, button, input, select, textarea, label')) {
      var href = blockLink.getAttribute('data-href');
      if (href) {
        event.preventDefault();
        var target = blockLink.getAttribute('data-target') || blockLink.getAttribute('target');
        if (target === '_blank') window.open(href, '_blank'); else window.location.href = href;
      }
    }
  });
})();
